module.exports = __webpack_public_path__ + "assets/b21.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b21.png
// module id = 607
// module chunks = 0